import MarketplaceCard from '../../components/MarketplaceCard/MarketplaceCard';

const ProductCard = ({ listing }) => {
  return <MarketplaceCard listing={listing} variant="resale" />;
};

export default ProductCard;
